// @flow

export const customStyles: any = {
  control: (style: any) => ({
    ...style,
    minHeight: 35,
    borderColor: '#d1d9e1 #c2ccd7 #a3b2c3',
    borderRadius: '2px',
    border: '1px solid #c2ccd7',
    color: '#333',
    cursor: 'default',
    outline: 'none',
    overflow: 'hidden',
    position: 'relative'
  }),
  input: (style: any) => ({
    ...style,
    paddingLeft: 10
  }),
  placeholder: (style: any) => ({
    ...style,
    paddingLeft: 10
  }),
  valueContainer: (style: any) => ({
    ...style,
    padding: 0
  }),
  singleValue: (style: any, state: any) => ({
    ...style,
    color: state.isDisabled ? 'hsl(0,0%,70%)' : state.color,
    paddingLeft: 10
  }),
  multiValue: (style: any) => ({
    ...style,
    marginLeft: 10,
    marginRight: 5,
    color: '#f7f9fc',
    backgroundColor: '#f7f9fc',
    border: '1px solid #e0e6ec'
  }),
  clearIndicator: (style: any) => ({
    ...style,
    cursor: 'pointer',
    display: 'flex',
    padding: 0,
    alignItems: 'center',
    width: 10,
    height: 10,
    ':hover': {
      color: '#d43c3a'
    }
  }),
  multiValueLabel: (style: any, state: any) => ({
    ...style,
    paddingRight: 6,
    color: state.isDisabled ? 'hsl(0, 0%, 70%)' : '#797c8c'
  }),
  multiValueRemove: (style: any) => ({
    ...style,
    paddingLeft: 0,
    cursor: 'pointer',
    color: '#797c8c',
    ':hover': {
      backgroundColor: '#e0e6ec'
    }
  }),
  option: (style: any, state: any) => ({
    ...style,
    color: state.isSelected ? 'inherit' : style.color,
    backgroundColor: state.isFocused ? '#e0e6ec' : 'transparent',
    ':active': {
      ...style[':active'],
      backgroundColor: '#e0e6ec'
    }
  })
};
